import { render } from "./DropdownModule.vue?vue&type=template&id=09bb18de&scoped=true"
import script from "./DropdownModule.vue?vue&type=script&lang=js"
export * from "./DropdownModule.vue?vue&type=script&lang=js"

import "./DropdownModule.vue?vue&type=style&index=0&id=09bb18de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09bb18de"]])

export default __exports__